import { AllergyIcon } from './AllergyIcon';

/**
 * author: Michael Richins
 * id 76B6381F-14CA-4453-8B28-184C508D003B
 * name allergy
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/allergy.svg
 * tags
 * - Medical / Hospital 
 */
export const RashIcon = AllergyIcon;
export default RashIcon